import {AnyAction, CombinedState, combineReducers} from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

import auth, {AuthUser} from "./authSlice";
import expertProfile, {ExpertProfile} from "./expertProfile";
import lessons, {Lessons} from "./lessonsSlice";
import expertsCountry, {IExpertsCountry} from "./expertsCountrySlice";
import home, {IHome} from "./homeSlice";
import app, {IApp} from "./appSlice";
import bankDetails, {IBankDetails} from "./bankDetailsSlice";
import experts, {IExperts} from "./expertsListSlice";
import expertSchedule, {IExpertSchedule} from "./expertScheduleSlice";
import studentLessons, {IStudentLessons} from "./studentLessonsSlice";
import reservations, {Reservations} from "./reservationsSlice";
import profileSlice, {ProfileSliceInterface} from "./profileSlice";
import purchase, {IPurchase} from "./purchaseSlice";
import purchaseHistory, {IPurchaseHistory} from "./purchaseHistorySlice";
import homeNotices, {IHomeNotices} from "./homeNoticesSlice";
import lessonsRevenueHistory, {
  IRevenue,
} from "./expertLessonsRevenueHistorySlice";
import paymentHistory, {IPayment} from "./expertPaymentHistorySlice";
import points,{IPoints} from "./pointsSlice";
import  selectedExpertPageSlice,{ISelectedExpertPage} from "./selectedExpertPageSlice";
import reservationGroupSlice,{IReservationGroup} from "./studentReservationGroupLessons";
import reservationIndividualNotUsedSlice,{IReservationIndividualNotUsed} from "./reservationIndividualNotUsedSlice";
import reservationIndividualReservedSlice,{IReservationIndividualReserved} from "./reservationIndividualReservedSlice";
import reservationIndividualCompletedSlice,{IReservationIndividualCompleted} from "./reservationIndividualCompletedSlice";

export interface RootSliceType {
  app: IApp;
  auth: AuthUser;
  home: IHome;
  expertProfile: ExpertProfile;
  lessons: Lessons;
  expertsCountry: IExpertsCountry;
  experts: IExperts;
  bankDetails: IBankDetails;
  expertSchedule: IExpertSchedule;
  reservations: Reservations;
  profileSlice: ProfileSliceInterface;
  studentLessons: IStudentLessons;
  lessonsRevenueHistory: IRevenue;
  paymentHistory: IPayment;
  purchase: IPurchase;
  purchaseHistory: IPurchaseHistory;
  homeNotices: IHomeNotices;
  points:IPoints;
  selectedExpertPageSlice:ISelectedExpertPage;
  reservationGroupSlice:IReservationGroup;
  reservationIndividualNotUsedSlice:IReservationIndividualNotUsed;
  reservationIndividualCompletedSlice:IReservationIndividualCompleted;
  reservationIndividualReservedSlice:IReservationIndividualReserved;
}

const lessonsConfig = {
  key: 'lessons',
  storage,
  whitelist: ["selectedLesson"],
}

const appReducer = combineReducers<RootSliceType>({
  app,
  auth,
  home,
  expertProfile,
  // @ts-ignore
  lessons : persistReducer(lessonsConfig, lessons),
  expertsCountry,
  experts,
  bankDetails,
  expertSchedule,
  studentLessons,
  reservations,
  profileSlice,
  lessonsRevenueHistory,
  purchase,
  purchaseHistory,
  homeNotices,
  paymentHistory,
  points,
  selectedExpertPageSlice,
  reservationGroupSlice,
  reservationIndividualNotUsedSlice,
  reservationIndividualCompletedSlice,
  reservationIndividualReservedSlice,
});

const rootReducer = (
  state: CombinedState<RootSliceType> | undefined,
  action: AnyAction
) => {
  if (action.type === "auth/logOut") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
